module.exports = __webpack_public_path__ + "img/8-Look_Man.ce27eb7.png";